import React from "react";
import Button from "@material-ui/core/Button";
import { CardActions, CreateButton, ExportButton, RefreshButton } from "react-admin";

const Actions = ({
	bulkActions,
	basePath,
	currentSort,
	displayedFilters,
	exporter,
	filters,
	filterValues,
	onUnselectItems,
	resource,
	selectedIds,
	showFilter,
	total,
	create = false,
	isExport = false
}) => (
	<CardActions>
		{bulkActions && React.cloneElement(bulkActions, {
			basePath,
			filterValues,
			resource,
			selectedIds,
			onUnselectItems,
		})}
		{filters && React.cloneElement(filters, {
			resource,
			showFilter,
			displayedFilters,
			filterValues,
			context: "button",
		})}
		{create && <CreateButton basePath={basePath} />}
		{isExport && <ExportButton
			disabled={total === 0}
			resource={resource}
			sort={currentSort}
			filter={filterValues}
			exporter={exporter}
		/>}
		<RefreshButton />
	</CardActions>
);

export default Actions;


// WEBPACK FOOTER //
// ./src/components/Actions.js